import { render } from "./TestCaseDetailDialog.vue?vue&type=template&id=cfd76d9e&scoped=true"
import script from "./TestCaseDetailDialog.vue?vue&type=script&lang=js"
export * from "./TestCaseDetailDialog.vue?vue&type=script&lang=js"

import "./TestCaseDetailDialog.vue?vue&type=style&index=0&id=cfd76d9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfd76d9e"]])

export default __exports__